import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// login
import LoginReducer from "./auth/login/reducer";
import DashboardReducer from "./dashboard/reducer";

import CompanyReducer from "./companies/reducer";

import DepartmentReducer from "./department/reducer";
import DesignationReducer from "./designation/reducer";
import RoleReducer from "./role/reducer";

import UserReducer from "./employees/reducer";
import UserSalaryReducer from './salarypayroll/reducer';

import AttendanceReducer from "./attendance/reducer";

import LeavesReducer from "./leaves/reducer";
import ExpensesReducer from "./expenses/reducer";
import DailyUpdateReducer from "./dailyupdates/reducer";



import AssetReducer from "./assets/reducer";
import LoansReducer from "./loans/index";

import NotificationReducer from "./notification/reducer";

// Resumes
import ResumeReducer from "./resumes/reducer";

// Interview
import InterviewReducer from "./interview/reducer";

import ContactFormReducer from "./contactForm/reducer";

// register
import RegisterReducer from "./auth/register/reducer";

// userProfile
import ProfileReducer from "./auth/profile/reducer";

// Chat
import ChatReducer from "./chat/reducer";
import EngageReducer from "./engage/reducer";

// MailBox
import MailboxReducer from "./mailbox/reducer";

// Calendar
import CalendarReducer from "./calendar/reducer";

// Ecommerce
import EcommerceReducer from "./ecommerce/reducer";

// Notes
import NotesReducer from "./notes/reducer";

// Invoice
import InvoiceReducer from "./invoice/reducer"

// Feedback
import FeedbackReducer from "./feedback/index";

// Email
import EmailReducer from "./email/reducer";

// Sender Email
import SenderEmailReducer from "./senderEmail/reducer";

// Admin Password
import AdminPasswordReducer from "./adminPassword/reducer";

// Admin Email Verification
import AdminEmailVerificationReducer from "./adminEmailVerification/reducer";

// Geofence
import GeofenceReducer from "./geofence/index";

// Visits
import VisitsReducer from "./visits/reducer";

// Anomaly Detection
import AnomalyDetectionReducer from "./anomalyDetection";

// Crashlytics
import CrashlyticsReducer from "./crashlytics/crashlyticsSlice";
import CallsReducer from "./calls/reducer";

// Tickets
import TicketsReducer from "./tickets/reducer";

// HR Management
import HRManagementReducer from "./hrManagement/reducer";

// Petty Cash
import PettyCashReducer from "./pettyCash/reducer";

// Performance Review
import PerformanceReviewReducer from "./performanceReview/reducer";

// Weekly Learning
import WeeklyLearningReducer from "./weeklyLearning/reducer";

// Menu Permissions
import { menuPermissionsReducer } from "./menuPermissions";

// QR Generator
import QRGeneratorReducer from "./qrGenerator/reducer";

// Time Tracking
import TimeTrackingReducer from "./timeTracking/reducer";

// Availability
import AvailabilityReducer from "./availability/reducer";

// Meeting Request
import MeetingRequestReducer from "./meetingRequest/reducer";

// Exit Management
import ExitManagementReducer from "./exitManagement/reducer";

// AI Assistant
import AIAssistantReducer from "./aiAssistant/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Dashboard: DashboardReducer,
    Companies: CompanyReducer,
    Department: DepartmentReducer,
    Designation: DesignationReducer,
    Role: RoleReducer,
    Employees: UserReducer,
    Assets: AssetReducer,
    Loans: LoansReducer,
    SalaryPayroll: UserSalaryReducer,
    EmpAttendance: AttendanceReducer,
    Leaves: LeavesReducer,
    Expenses: ExpensesReducer,
    DailyUpdates: DailyUpdateReducer,

    Resumes: ResumeReducer,
    Interview: InterviewReducer,
    ContactForm: ContactFormReducer,
    Register: RegisterReducer,
    Profile: ProfileReducer,
    Chat: ChatReducer,
    Engage: EngageReducer,
    Mailbox: MailboxReducer,
    Calendar: CalendarReducer,
    Ecommerce: EcommerceReducer,
    Notes: NotesReducer,
    Invoice: InvoiceReducer,
    Notification: NotificationReducer,
    Feedback: FeedbackReducer,
    Email: EmailReducer,
    SenderEmail: SenderEmailReducer,
    AdminPassword: AdminPasswordReducer,
    AdminEmailVerification: AdminEmailVerificationReducer,
    Geofence: GeofenceReducer,
    Visits: VisitsReducer,
    AnomalyDetection: AnomalyDetectionReducer,
    Crashlytics: CrashlyticsReducer,
    Calls: CallsReducer,
    Tickets: TicketsReducer,
    HRManagement: HRManagementReducer,
    PettyCash: PettyCashReducer,

    PerformanceReview: PerformanceReviewReducer,
    WeeklyLearning: WeeklyLearningReducer,
    MenuPermissions: menuPermissionsReducer,
    QRGenerator: QRGeneratorReducer,
    TimeTracking: TimeTrackingReducer,
    Availability: AvailabilityReducer,
    MeetingRequest: MeetingRequestReducer,
    ExitManagement: ExitManagementReducer,
    AIAssistant: AIAssistantReducer,
});

export default rootReducer;